/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/Logger',['./Console'],
    function () {
        'use strict';

        var LoggingThresholds = {
            DEBUG: 1,
            LOG: 2,
            INFO: 3,
            WARN: 4,
            ERROR: 5
        };
        var noop = function() {};
        var CurrentLoggingThreshold = LoggingThresholds.ERROR;
        
        if (window.RocConfig && window.RocConfig.logging && window.RocConfig.logging.threshold) {
            CurrentLoggingThreshold = LoggingThresholds[window.RocConfig.logging.threshold];

            if (!CurrentLoggingThreshold) {
                CurrentLoggingThreshold = LoggingThresholds.WARN;
            }

            if (CurrentLoggingThreshold === LoggingThresholds.DEBUG) {
                console.warn('Debug logging is enabled.');
            }
        }

        //we can use this module to override default logging behavior and turn it on/off.
        function extendedLogging(fn) {
            return function () {
                try {
                    var args = [].slice.call(arguments);
                    fn.apply(console, args);
                }
                catch (err) {
                    //prevent from terminating other js calls
                }
            }
        }

        function extendedLoggingWithThreshold(threshold, consoleFn) {
            if (CurrentLoggingThreshold > threshold) {
                return noop;
            }

            return extendedLogging(consoleFn);
        }

        var Logger = {
            debug: extendedLoggingWithThreshold(LoggingThresholds.DEBUG, console.debug),
            log: extendedLoggingWithThreshold(LoggingThresholds.LOG, console.log),
            info: extendedLoggingWithThreshold(LoggingThresholds.INFO, console.info),
            warn: extendedLoggingWithThreshold(LoggingThresholds.WARN, console.warn),
            error: extendedLoggingWithThreshold(LoggingThresholds.ERROR, console.error)
        };

        return Logger;
    });
